import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import labels from "../../../config/labels";
import microService from "../../../utils/microServices";
import {
  connect,
  CustomContainer,
  useRouter,
  useDispatch,
} from "../../atoms/DependencyHelper";
import ResultInformation from "../../atoms/resultInformation/ResultInformation";
import SnackBar from "../../atoms/snackBar/SnackBar";
import InfoWithButton from "../../molecules/infoWithButton/InfoWithButton";
import OtpComponent from "../../molecules/otpComponent/OtpComponent";
import styles from "./CheckoutMahAuthentication.module.scss";
import * as Analytics from "../../../services/analyticsUtag";
import ajaxService from "../../../utils/ajaxServices";
import {
  hideSpinner,
  showSpinner,
  urlPrefix,
  setCookieConsentWrapper,
  getPreValidationErrorType,
  preValidationUpgradeEligible,
  preValidationEligible,
  imagePrefix,
  generateFormURL,
} from "../../../utils/helperServices";
import {
  SET_SKIP_CREDIT_VETTING,
  ADD_CREDIT_PROFILE,
  SET_CREDIT_CHECK_AFFORD_DEAL,
} from "../../../Redux/actionTypes/index";
import NumberCheckComponent from "../../molecules/numberCheckComponent/NumberCheckComponent";
import { maskMsisdn, newMaskMsisdn } from "../../../services/upgradeService";
import DeliveryTitle from "../../atoms/deliveryTitle/DeliveryTitle";
import { journeyType } from "../../../context/checkout-journey-context";
import config from "../../../config/index";
import { preValidationCheckService } from "../../../services/checkoutService";

import {
  Logger,
} from "../../../utils/logger";

const CheckoutMahAuthentication = forwardRef(
  (
    {
      authDetailsData,
      setShowTooltip,
      continueDisable,
      userLoggedIn,
      profileData,
      customerStatus,
      setPageErr,
      navigate,
      upgradeResponse,
      handleHeading,
      currentJourney,
      dealID,
      multicartFlag,
      numberTransferEnabled,
    },
    ref
  ) => {
    const [otp, setOtp] = useState(Array(6).fill(""));
    const [showSnackBar, setShowSnackBar] = useState(false);
    const [invalidAttempts, setInvalidAttempts] = useState(0);
    const [otpCheckBox, setOtpCheckBox] = useState(true);
    const [otpSent, setOtpSent] = useState(false);
    const [newOtp, setNewOtp] = useState();
    const [selectedNumber, setSelectedNumber] = useState();
    const [selectedmaskedNumber, setSelectedmaskedNumber] = useState("");
    const [showResult, setShowResult] = useState({
      visible: false,
    });
    const [allPreviligedNumbers, setAllPreviligedNumbers] = useState([]);
    const [selectAnotherOtpNumber, setSelectAnotherOtpNumber] = useState(false);
    const analyticsPageName = "lets get started";
    const dispatch = useDispatch();
    const router = useRouter();
    const addOnlineLeadType =
      "verification_of_existing_customer_addon_line_otp";
    const leadFormUrl = `${urlPrefix}/forms/ecommerce`;

    useEffect(() => {
      if (currentJourney == journeyType.addLine) {
        upgradeResponse.mah = true;
        handleHeading(
          "update",
          "title",
          `${labels.post_checkout.otp_authentication.lbl_main_heading}`
        );
      }
    }, []);

    useEffect(() => {
      if (authDetailsData?.information?.authorisedNumbers?.length > 0) {
        if (authDetailsData?.information?.authorisedNumbers?.length === 1) {
          let numberSelected =
            authDetailsData?.information?.authorisedNumbers[0]?.standardFormat;
          resendOTP(numberSelected);
          setSelectedNumber(numberSelected);
          setSelectedmaskedNumber(maskMsisdn(numberSelected));
        } else {
          if (upgradeResponse.mah) {
            if (currentJourney == journeyType.addLine) {
              handleHeading("hide", "desc");
            } else {
              handleHeading(
                "update",
                "desc",
                labels.mah_authentication.lbl_will_send_otp
              );
            }
          } else {
            handleHeading(
              "update",
              "title",
              labels.mah_authentication.lbl_mah_auth
            );
            handleHeading(
              "update",
              "desc",
              labels.mah_authentication.lbl_mah_auth_desc
            );
          }
          let numbersList = authDetailsData?.information?.authorisedNumbers.map(
            (item, key) => {
              return {
                id: item?.standardFormat,
                label: maskMsisdn(item?.standardFormat),
              };
            }
          );
          setAllPreviligedNumbers(numbersList);
          setSelectedNumber(numbersList[0].id);
          setSelectedmaskedNumber(maskMsisdn(numbersList[0].label));
        }
        Analytics.view({
          page_event: "view",
          page_name: `checkout: ${analyticsPageName}: ${customerStatus} ${
            currentJourney == journeyType.addLine ? "send otp" : "enter otp"
          }`,
          page_channel: "checkout",
          page_master_tab: "personal",
          multicart_flag: multicartFlag ? true : false,
          ...Analytics.getProfileData(userLoggedIn, profileData, authDetailsData),
        });
      }
    }, [authDetailsData]);

    useImperativeHandle(ref, () => ({
      submit: () => {
        Analytics.link({
          link_type: "o",
          link_name: `checkout: ${analyticsPageName}: ${customerStatus}: continue`,
        });

        continueDisable(true);
        if (currentJourney == journeyType.addLine) {
          //check prevalidation and navigate to credit check
          preValidationCheck(journeyType.addLine, "creditCheck");
        } else {
          //check prevalidation and navigate to (Number transfer if it is enabled or delivery details)
          preValidationCheck(journeyType.upgrade, "delivery");
        }
      },
      back: () => {
        Analytics.link({
          link_type: "o",
          link_name: `checkout: ${analyticsPageName}: ${customerStatus}: back to lets get started`,
        });
      },
    }));

    const handlePrimaryClick = (url, label) => {
      showSpinner();
      ctaAnalytics(label);
      const navigateUrl = url === "/" ? url : `${urlPrefix}${url}`;

      if (url) {
        if (label.includes(labels.mah_authentication.lbl_pay_my_bill)) {
          router.push(url).then(() => {
            hideSpinner();
          });
          return;
        }

        router.push(navigateUrl).then(() => {
          hideSpinner();
        });
      } else {
        router.push(`${urlPrefix}/forms/ecommerce`).then(() => {
          hideSpinner();
        });
      }
    };

    const handleSecondaryClick = (url, label) => {
      showSpinner();
      ctaAnalytics(label);
      const navigateUrl = url === "/" ? url : `${urlPrefix}${url}`;

      if (url) {
        if (label.includes(labels.mah_authentication.lbl_pay_my_bill)) {
          router.push(url).then(() => {
            hideSpinner();
          });
          return;
        }

        router.push(navigateUrl).then(() => {
          hideSpinner();
        });
      } else {
        router.push(`${urlPrefix}/cart`).then(() => {
          hideSpinner();
        });
      }
    };

    const fetchErrorDetails = async (
      resultCode,
      pageName,
      pageErrorType,
      additionalUtagData = null,
      preferences = []
    ) => {
      const newResultCode = multicartFlag
        ? resultCode + "_multicart"
        : resultCode;
      setShowTooltip({ visible: false, message: "" });

      try {
        showSpinner();
        const result = await ajaxService.httpGet(
          "drupalBaseUrl",
          "",
          "api",
          "errorResultDetails",
          [newResultCode]
        );

        setPageErr({
          type: "error",
          title: result[0].resultTitle,
          desc:
            result[0].resultText && result[0].resultText !== ""
              ? result[0].resultText
              : result[0].resultHTML,
          primaryLabel:
            result[0].primaryEnabled === "Yes"
              ? result[0].primaryCTAText
              : null,
          primaryUrl:
            result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
          secondaryLabel:
            result[0].secondaryEnabled === "Yes"
              ? result[0].secondaryCTAText
              : null,
          secondaryUrl:
            result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
          handlePrimaryClick: (preferenceId) =>
            handlePrimaryClick(
              generateFormURL(
                result[0].primaryCTAURL,
                result[0].leadType,
                result[0].primaryCTAType,
                preferenceId
              ),
              result[0].primaryCTAText
            ),
          handleSecondaryClick: () =>
            handleSecondaryClick(
              generateFormURL(
                result[0].secondaryCTAURL,
                result[0].leadType,
                result[0].secondaryCTAType
              ),
              result[0].secondaryCTAText
            ),
          imgUrl: result[0].icon,
          pageName: pageName,
          pageErrorType: pageErrorType
            ? pageErrorType
            : result[0].analyticTitle !== resultCode
            ? result[0].analyticTitle
            : "technical error",
          additionalUtagData: additionalUtagData,
          dividerLine: result[0].CTATitle != "" ? true : false,
          ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
          disablePrimary:
            multicartFlag && preferences.length > 0 ? true : false,
          preferences: multicartFlag ? preferences : [],
          defaultPreference:
            multicartFlag && result[0].primaryCTAURL?.includes("/checkout")
              ? "once-off"
              : null,
        });
        hideSpinner();
        //navigate to checkout page error
        navigate("pageError");
      } catch {
        if (multicartFlag) {
          setPageErr({
            type: "error",
            title: labels.checkout.lbl_invalid_attempt_title,
            desc: labels.checkout.lbl_invalid_attempt_desc,
            primaryLabel: "Continue",
            secondaryLabel: null,
            handlePrimaryClick: (preferenceId) =>
              handlePrimaryClick(
                generateFormURL(
                  "/forms/ecommerce",
                  "pre_validation_checks",
                  "lead",
                  preferenceId
                ),
                "continue"
              ),
            imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
            pageName: pageName,
            pageErrorType: pageErrorType ? pageErrorType : "technical error",
            additionalUtagData: additionalUtagData,
            dividerLine: true,
            ctaTitle: labels.checkout.lbl_select_preference,
            disablePrimary: true,
            preferences: labels.checkout.lbl_preference_values,
          });
        } else {
          setPageErr({
            type: "error",
            title: labels.auth.lbl_technical_error_title,
            desc: labels.auth.lbl_technical_error_desc,
            primaryLabel: "Call me back",
            secondaryLabel: "Exit checkout",
            handlePrimaryClick: () => handlePrimaryClick(null, "call me back"),
            handleSecondaryClick: () =>
              handleSecondaryClick(null, "exit checkout"),
            imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
            pageName: pageName,
            pageErrorType: pageErrorType ? pageErrorType : "technical error",
            additionalUtagData: additionalUtagData,
          });
        }
        hideSpinner();
        //navigate to checkout page error
        navigate("pageError");
      }
    };

    const preValidationCheck = async (journey, page) => {
      showSpinner();
      let idNumber = authDetailsData?.idNumber;

      let results = await preValidationCheckService(
        authDetailsData?.idType,
        idNumber,
        dealID,
        journey
      );

      hideSpinner();

      if (results?.responseCode) {
        if (journey == journeyType.addLine) {
          dispatch({
            type: SET_SKIP_CREDIT_VETTING,
            payload: results.skipCreditVetting,
          });

          if (
            results.responseCode == "PREVALIDATION_NOT_ELIGIBLE_NOT_AFFORDABLE"
          ) {
            dispatch({
              type: ADD_CREDIT_PROFILE,
              payload: results.creditFilters,
            });
            dispatch({
              type: SET_CREDIT_CHECK_AFFORD_DEAL,
              payload: true,
            });
          } else {
            dispatch({
              type: SET_CREDIT_CHECK_AFFORD_DEAL,
              payload: false,
            });
          }

          if (preValidationEligible(results.responseCode)) {
            let newPage =
              page == "creditCheck" && results.skipCreditVetting
                ? "review"
                : page;
            navigate(newPage);
          } else {
            const pageErrorType = getPreValidationErrorType(
              results.responseCode
            );

            Logger.info(
              `Prevalidation check returned code ${results.responseCode}`,
              "CheckoutMahAuthentication",
              {
                TagErrorType: pageErrorType || "not returned",
                ServiceResponseCode: results.responseCode,
                response: JSON.stringify(results || {}),
                data: {
                  idType: authDetailsData?.idType,
                  idNumber,
                  dealID,
                  journey
                }
              },
              { preval_result_code: results.responseCode }
            );

            fetchErrorDetails(
              results.responseCode,
              `checkout: pre val: ${customerStatus}`,
              pageErrorType,
              "authentication_id_type"
            );
          }
        } else {
          //upgrade checkout
          if (preValidationUpgradeEligible(results.responseCode)) {
            navigate(page);
          } else {
            const pageErrorType = getPreValidationErrorType(
              results.responseCode
            );

            Logger.info(
              `Prevalidation check returned code ${results.responseCode}`,
              "CheckoutMahAuthentication",
              {
                TagErrorType: pageErrorType || "not returned",
                ServiceResponseCode: results.responseCode,
                response: JSON.stringify(results || {}),
                data: {
                  idType: authDetailsData?.idType,
                  idNumber,
                  dealID,
                  journey
                }
              },
              { preval_result_code: results.responseCode }
            );

            fetchErrorDetails(
              results.responseCode,
              `checkout: pre val: ${customerStatus}`,
              pageErrorType,
              "authentication_id_type"
            );
          }
        }
      } else {

        fetchErrorDetails(
          `preValidation_${results.errors?.status}`,
          `checkout: pre val: ${customerStatus}`,
          "technical error",
          "authentication_id_type",
          labels.checkout.lbl_preference_values
        );

        Logger.error(
          "No pre validation response code returned",
          "CheckoutMahAuthentication",
          {
            response: JSON.stringify(results || {}),
            data: {
              idType: authDetailsData?.idType,
              idNumber,
              dealID,
              journey
            }
          }
        );
      }
    };

    const cantReciveOtpButtonHandler = (label) => {
      ctaAnalytics(label);
      if (
        currentJourney == journeyType.addLine &&
        (label.toLowerCase() == "call me back" ||
          label.toLowerCase() ==
            labels.mah_authentication.lbl_cant_receive_otp.toLowerCase())
      ) {
        showSpinner();
        router
          .push(generateFormURL(leadFormUrl, addOnlineLeadType, "lead"))
          .then(() => {
            hideSpinner();
          });
      } else {
        fetchErrorDetails(
          `upgradecheckout_cant_generate_otp`,
          `checkout: ${analyticsPageName}: ${customerStatus}`,
          `can't otp`,
          null,
          labels.checkout.lbl_preference_values
        );
      }
    };

    const getUtagViewData = () => {
      return Analytics.getUtagData([
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_login_status",
        "visitor_subscription_type",
        "visitor_msisdn_hash",
        "page_name",
        "page_channel",
        "page_master_tab",
        "multicart_flag",
      ]);
    };

    const ctaAnalytics = (label) => {
      if (label) {
        const pageName =
          currentJourney == journeyType.addLine
            ? `checkout: ${analyticsPageName}: ec`
            : Analytics.getUtagData(["page_name"]).page_name;
        if (label.toLowerCase() == "resend otp") {
          Analytics.link({
            page_tool_event: "use",
            page_tool_name: `${pageName}: ${label.toLowerCase()}`,
            ...getUtagViewData(),
          });
        } else {
          Analytics.link({
            link_type: "o",
            link_name: `${pageName}: ${label}`,
            ...getUtagViewData(),
          });
        }
      }
    };

    const validateOTP = async () => {
      const otpValue = otp.join("");
      try {
        showSpinner();
        ctaAnalytics(" Validate OTP");
        setShowTooltip({ visible: false, message: "" });
        const urlParams = `?idNumber=${authDetailsData.idNumber}&docType=${
          authDetailsData.idType
        }&maskedMsisdn=${newMaskMsisdn(selectedNumber)}&otp=${otpValue}`;
        const responseData = await microService.post(
          "api",
          "authenticateAlternativeNumber",
          {},
          null,
          false,
          null,
          urlParams
        );
        if (responseData.fail) {
          if (responseData.error.status === 401) {
            let occurance = invalidAttempts + 1;
            setInvalidAttempts(occurance);
            if (invalidAttempts === 0) {
              displayTooltip(labels.upgrade.lbl_invalid_otp_try_1, occurance);
            } else {
              displayTooltip(labels.upgrade.lbl_invalid_otp_try_2, occurance);
            }
            setOtp(Array(6).fill(""));
          } else if (responseData.error.status === 400) {
            fetchErrorDetails(
              `upgradecheckout_max_invalid_otps`,
              `checkout: ${analyticsPageName}: ${customerStatus}`,
              `otp failed third time`
            );
          } else if (responseData.error.status === 404) {
            fetchErrorDetails(
              `upgradecheckout_technical_error`,
              `checkout: ${analyticsPageName}: ${customerStatus}`,
              `siebel`,
              null,
              labels.checkout.lbl_preference_values
            );
          } else {
            fetchErrorDetails(
              `upgradecheckout_technical_error`,
              `checkout: ${analyticsPageName}: ${customerStatus}`,
              `siebel`,
              null,
              labels.checkout.lbl_preference_values
            );
          }
        } else {
          handleHeading("hide", "desc");
          setShowResult({
            visible: true,
            analyticsType: "success",
            iconType: "success",
            title:
              currentJourney == journeyType.addLine
                ? labels.post_checkout.otp_authentication.lbl_otp_success
                : labels.mah_authentication.lbl_success_title,
          });
          continueDisable(false);
          //Create cookie with JWT token here
          setCookieConsentWrapper(
            "vod-web-auth-otp-token",
            [config.cookie_category.strictly_necessary],
            `document.cookie='vod-web-auth-otp-token=${responseData.response?.data?.result};path=/'`
          );
        }
      } catch (error) {
        hideSpinner();
        fetchErrorDetails(
          `upgradecheckout_technical_error`,
          `checkout: ${analyticsPageName}: ${customerStatus}`,
          `siebel`,
          null,
          labels.checkout.lbl_preference_values
        );
      } finally {
        hideSpinner();
      }
    };

    const resendOTP = async (maskedMsisdn, label = "") => {
      if (label) {
        ctaAnalytics(label);
      }
      setShowTooltip({ visible: false, message: "" });
      setOtp(Array(6).fill(""));
      try {
        showSpinner();
        const urlParams = `?idNumber=${authDetailsData.idNumber}&docType=${
          authDetailsData.idType
        }&maskedMsisdn=${newMaskMsisdn(maskedMsisdn)}`;
        const responseData = await microService.post(
          "api",
          "generateOtp",
          {},
          null,
          false,
          null,
          urlParams
        );
        if (responseData.fail) {
          fetchErrorDetails(
            `upgradecheckout_technical_error`,
            `checkout: ${analyticsPageName}: ${customerStatus}`,
            `siebel`,
            null,
            labels.checkout.lbl_preference_values
          );
        } else {
          if (currentJourney == journeyType.addLine) {
            handleHeading("show", "desc");
            handleHeading(
              "update",
              "desc",
              `${
                labels.post_checkout.otp_authentication.lbl_sub_heading
              } ${maskMsisdn(maskedMsisdn)}${
                labels.post_checkout.otp_authentication.lbl_sub_heading_2
              }`
            );
            Analytics.view({
              page_event: "view",
              page_name: `checkout: ${analyticsPageName}: ec enter otp`,
              page_channel: "checkout",
              page_master_tab: "personal",
              multicart_flag: multicartFlag ? true : false,
              ...Analytics.getProfileData(userLoggedIn, profileData, authDetailsData),
            });
          } else {
            handleHeading(
              "update",
              "desc",
              `${labels.mah_authentication.lbl_otp_sent_desc_1} ${maskMsisdn(
                maskedMsisdn
              )}${labels.mah_authentication.lbl_otp_sent_desc_2}`
            );
          }
          if (!otpSent) {
            setOtpSent(true);
          }
          if (otpSent) {
            setShowSnackBar(true);
          }
        }
      } catch (error) {
        hideSpinner();
        fetchErrorDetails(
          `upgradecheckout_technical_error`,
          `checkout: ${analyticsPageName}: ${customerStatus}`,
          `siebel`,
          null,
          labels.checkout.lbl_preference_values
        );
      } finally {
        hideSpinner();
      }
    };

    useEffect(() => {
      if (currentJourney == journeyType.addLine && !otpSent) {
        handleHeading("hide", "desc");
      }
    }, [otpSent]);

    useEffect(() => {
      if (showSnackBar) {
        let timer = setTimeout(() => closeSnackBar(), 3000);
        return () => {
          clearTimeout(timer);
        };
      }
    }, [showSnackBar]);

    const displayTooltip = (message, occurance) => {
      setShowTooltip({ visible: true, message: message });
      let occurance_word = "";
      if (occurance == 1) {
        occurance_word = "once";
      } else if (occurance == 2) {
        occurance_word = "twice";
      } else if (occurance >= 3) {
        occurance_word = "thrice";
      }
      Analytics.view({
        ...getUtagViewData(),
        page_name: `checkout: ${analyticsPageName}:  ${customerStatus}: otp failed ${occurance_word}`,
      });
    };
    const closeSnackBar = () => {
      setShowSnackBar(false);
    };
    useEffect(() => {
      let numArray = [];
      for (let i = 0; i < otp.length; i++) {
        if (otp[i] != "") {
          numArray.push(otp[i]);
        }
      }
      setNewOtp(numArray);
    }, [otp]);

    const handleNumberSelect = (value) => {
      if (value !== selectedmaskedNumber && selectAnotherOtpNumber) {
        setSelectAnotherOtpNumber(false);
        setInvalidAttempts(0); //reset since the user chose another number
      }
      setSelectedmaskedNumber(value);
      const foundval = allPreviligedNumbers.find(
        (item) => item.label === value
      );
      setSelectedNumber(foundval.id);
    };

    const updateCheckBox = () => {
      setOtpCheckBox(!otpCheckBox);
      let pageName =
        currentJourney == journeyType.addLine
          ? `checkout: ${analyticsPageName}: ec`
          : Analytics.getUtagData(["page_name"]).page_name;
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: `${pageName}: ${
          otpCheckBox ? "I can't use sms" : "I can use sms"
        }`,
        ...getUtagViewData(),
      });
    };
    const numberButtonHandler = (label) => {
      if (otpCheckBox) {
        resendOTP(selectedNumber, label);
      } else {
        cantReciveOtpButtonHandler(label);
      }
    };

    const handleSendOtpToAnotherNumber = () => {
      setOtpSent(false);
      ctaAnalytics("Send OTP to another number");
      setSelectAnotherOtpNumber(true);
    };
    return (
      <CustomContainer className={styles["container"]}>
        {showSnackBar && (
          <SnackBar
            message={labels.upgrade.lbl_otp_resent_info}
            className={"defaultSnackBarStyling"}
            closeSnackBar={closeSnackBar}
            isVisible={showSnackBar}
          />
        )}
        {!upgradeResponse?.mah && !showResult.visible && (
          <DeliveryTitle
            contents={[labels.mah_authentication.lbl_mah_info]}
            className={styles["standard-box"]}
            id={`checkout-xds-standard-delivery`}
            iconType="info"
          />
        )}
        {!showResult.visible && (
          <>
            <CustomContainer className={styles["titleSection"]}>
              {otpSent ? (
                <p className={styles["title"]}>
                  {upgradeResponse?.mah
                    ? labels.mah_authentication.lbl_enter_otp_title
                    : labels.mah_authentication.lbl_enter_mah_otp_title}
                </p>
              ) : (
                <>
                  <p className={styles["title"]}>
                    {labels.mah_authentication.lbl_where_to_sent_otp}
                  </p>
                  <p className={styles["description"]}>
                    {labels.mah_authentication.lbl_select_number}
                  </p>
                </>
              )}
            </CustomContainer>
            {otpSent ? (
              <>
                <OtpComponent
                  title={labels.mah_authentication.lbl_one_time_pin}
                  primaryButtonText={labels.mah_authentication.lbl_validate_otp}
                  primaryButtonStyle={
                    newOtp && newOtp.length == 6
                      ? "solid black"
                      : "solid light gray"
                  }
                  primaryButtonDisabled={!(newOtp && newOtp.length == 6)}
                  primaryButtonHandler={validateOTP}
                  secondaryButtonText={labels.mah_authentication.lbl_resend_otp}
                  secondaryButtonStyle={"flat black"}
                  secondaryButtonDisabled={false}
                  secondaryButtonHandler={(label) =>
                    resendOTP(selectedNumber, label)
                  }
                  otpValue={otp}
                  otpHandler={setOtp}
                  showBackButton={allPreviligedNumbers.length > 1}
                  backButtonText={labels.mah_authentication.lbl_send_otp_other}
                  handleBackButton={() => handleSendOtpToAnotherNumber()}
                  containerClass={styles["otpComponentClass"]}
                />
                {upgradeResponse?.mah && !allPreviligedNumbers.length && (
                  <InfoWithButton
                    title={labels.mah_authentication.lbl_havent_received_otp}
                    description={`${
                      labels.mah_authentication.lbl_otp_sent_desc_1
                    } ${newMaskMsisdn(selectedNumber)}${
                      labels.mah_authentication.lbl_otp_sent_desc_2
                    }`}
                    buttonText={labels.mah_authentication.lbl_cant_receive_otp}
                    buttonHandler={cantReciveOtpButtonHandler}
                    containerClass={styles["cantReceiveClass"]}
                  />
                )}
              </>
            ) : (
              <>
                <NumberCheckComponent
                  buttonStyle={"solid black"}
                  buttonHandler={numberButtonHandler}
                  buttonDisabled={false}
                  buttonText={
                    otpCheckBox
                      ? labels.mah_authentication.lbl_send_otp
                      : labels.mah_authentication.lbl_call_me_back
                  }
                  showCheckBox={upgradeResponse?.mah}
                  checkValue={otpCheckBox}
                  checkBoxText={labels.upgrade.lbl_enter_msisdn_checkbox_text}
                  checkBoxHandler={updateCheckBox}
                  selectedNumber={selectedmaskedNumber}
                  numberList={allPreviligedNumbers}
                  handleNumberSelect={handleNumberSelect}
                />
              </>
            )}
          </>
        )}
        {showResult.visible && (
          <ResultInformation
            className={styles["information"]}
            title={showResult.title}
            analyticsType={showResult.analyticsType}
            iconType={showResult.iconType}
            formName="otp"
            pageName={`checkout: authentication: ${customerStatus}`}
          />
        )}
      </CustomContainer>
    );
  }
);

const mapStateToProps = (state) => ({
  authDetailsData: state.checkoutDetails.authDetails,
  upgradeResponse: state.upgrade.upgradeResponse,
});

export default connect(mapStateToProps, {}, null, {
  forwardRef: true,
})(CheckoutMahAuthentication);
